import type { LOCALE_CODE } from '~~/lib/ContentfulService';
import { convertContentfulToWebappLocaleCode } from '~/utils/convertContentfulToWebappLocaleCode';
import type { ActiveLocale } from '~/utils/locale/ActiveLocale';

/**
 * Builds the canonical {@link ActiveLocale} representation from a resolved
 * Contentful locale. Centralizes the Contentful-code -> webapp-form
 * conversion (e.g. "zh-Hant-TW" -> "zh-tw") behind a single factory instead
 * of ad hoc `.toLowerCase()` calls at each call site.
 */
export function buildActiveLocale(locale: {
  code: LOCALE_CODE;
  default: boolean;
}): ActiveLocale {
  return {
    webapp: convertContentfulToWebappLocaleCode(locale.code),
    contentfulCode: locale.code,
    isDefault: locale.default
  };
}
